<template>
  <div :id="questionId" class="questionModel" @clearValue="clearValue()">
    <div>
      <b-table-simple class="w-100">
        <b-tr
          class="mx-0 text-center align-middle"
          height="30 px"
          style="background-color: #f2effb"
        >
          <b-col></b-col
          ><b-col class="pr-0"
            ><response-history
              v-show="percentageValueId"
              :questionId="questionId"
              :rows="staticListCount"
              :surveyType="validationsType"
              :type="'static'"
          /></b-col>
        </b-tr>
        <b-tr
          v-for="idx in staticListCount"
          :key="'listAnswer' + idx"
          class="p-0"
          height="80 px"
          :style="bgc[(idx - 1) % 2]"
        >
          <b-td class="py-0 align-middle">
            <b-form-input
              :id="questionId + '_value' + '_' + idx"
              ref="observer"
              v-model="rowArray[idx - 1]"
              :name="name"
              :state="percentageState"
              class="form-control rowHeight text-center"
              type="text"
              @input="changeItem(idx)"
              @keydown="keyCheck($event, idx)"
              @paste.prevent
            />
          </b-td>
        </b-tr>
      </b-table-simple>
      <p v-if="currentPercentage > 0" :style="summaryColor" class="text-center font-weight-bold">
        Total: {{ currentPercentage }}%
      </p>
    </div>
  </div>
</template>
<script>
  import { mapActions } from 'vuex';
  import ResponseHistory from '../ResponseHistory.vue';

  export default {
    name: 'StaticPercentage',
    components: {
      ResponseHistory,
    },
    props: [
      'label',
      'name',
      'answer',
      'questionId',
      'validationsType',
      'staticListCount',
      'staticListQuestionId',
    ],
    data() {
      return {
        formData: {},
        rowData: '',
        rowArray: [],
        percentageSummary: 0,
        percentageState: null,
        currentPercentage: 0,
        bgc: ['background-color:#FAFAFA', 'background-color:#F6F4FF'],
      };
    },
    computed: {
      summaryColor() {
        if (this.currentPercentage == 100) {
          return 'color:green';
        } else {
          return 'color:red';
        }
      },
      percentageValueId() {
        return this.answer !== undefined ? this.answer[0]['Id'] : undefined;
      },
    },
    created() {
      this.rowData =
        this.answer !== undefined ? JSON.parse(this.answer[0]['Saved_Value_Long__c']) : '';
      if (this.rowData != '') {
        Object.entries(this.rowData).forEach(
          ([key, value]) => (this.rowArray[`${key}`] = `${value}`),
        );
        this.$emit('input', {
          value: JSON.stringify(Object.assign({}, this.rowArray)),
          id: this.percentageValueId,
        });
      } else this.rowArray = [];
    },
    mounted() {
      this.validatePercentage();
    },
    methods: {
      ...mapActions(['dirtySurvey']),
      keyCheck($event, idx) {
        if (this.rowArray[idx - 1] !== undefined) {
          if (this.rowArray[idx - 1].includes('.') && $event.key === '.') {
            $event.preventDefault();
          }
          if (
            ($event.key >= '0' && $event.key <= '9') ||
            $event.key === '.' ||
            $event.code === 'Backspace' ||
            $event.code === 'Delete' ||
            $event.code === 'ArrowLeft' ||
            $event.code === 'ArrowRight'
          ) {
          } else {
            $event.preventDefault();
          }
          if (/^\d+\.\d$/.test(this.rowArray[idx - 1])) {
            if ($event.code === 'Backspace') {
            } else {
              $event.preventDefault();
            }
          }
        }
      },
      changeItem(idx) {
        this.dirtySurvey(this.validationsType);
        if (this.rowArray[idx - 1] !== undefined) {
          let lastDigitIndex = this.rowArray[idx - 1].length - 1;
          if (this.rowArray[idx - 1][lastDigitIndex] == '.') {
            this.rowArray[idx - 1] = this.rowArray[idx - 1].slice(0, lastDigitIndex);
          }
        }
        this.emitValue();
      },
      validatePercentage() {
        let percentageSummary = this.calculatePercentage();
        if (percentageSummary == 100 || percentageSummary == 0) {
          document
            .getElementById(this.staticListQuestionId)
            .dispatchEvent(new Event('percentageValidationSuccess'));
          return true;
        } else {
          document
            .getElementById(this.staticListQuestionId)
            .dispatchEvent(new Event('percentageValidationFailed'));
          return false;
        }
      },
      calculatePercentage() {
        let sum = 0;
        let percentages = JSON.stringify(Object.assign({}, this.rowArray));
        let percentageValues = Object.values(JSON.parse(percentages));
        percentageValues.forEach(element => {
          if (element != '') {
            sum = sum + parseFloat(element);
          }
        });
        this.currentPercentage = sum;
        return sum;
      },
      clearValue() {
        this.rowArray = [];
        this.emitValue();
        this.percentageState = null;
      },
      emitValue() {
        this.$emit('input', {
          value: JSON.stringify(Object.assign({}, this.rowArray)),
          id: this.percentageValueId,
        });
        this.percentageState = this.validatePercentage();
      },
    },
  };
</script>
